import { ref } from "vue";

/**
 * 画面表示に関わる UI 状態を管理する composable。
 *
 * @returns 画面で利用するリアクティブな状態オブジェクト
 */
export const useMemberUiState = () => {
  const errdialog = ref(false); //エラーダイアログ
  const errMessage = ref(""); //エラーメッセージ
  const editPage = ref(false);
  const confirmPage = ref(false);
  const processFlag = ref(0);
  const confirmDeleteDialog = ref(false);
  const addressDialog = ref(false);
  const areaDialog = ref(false);
  const overlay = ref(false);
  const displayListSettingDialog = ref<boolean>(false);
  const displayListSearchDialog = ref<boolean>(false);

  /**
   * 検索ダイアログ表示 @Click
   */
  const onClickListSearch = (): void => {
    // 一覧設定ダイアログ表示
    displayListSearchDialog.value = true;
  };

  /**
   * 会員一覧ページ 開く
   */
  const openListPage = (): void => {
    //編集ページ表示 OFF
    editPage.value = false;
    //確認ページ表示 OFF
    confirmPage.value = false;
  };

  /**
   * 会員削除確認ページ 開く
   */
  const openConfirmDeletePage = (): void => {
    //処理フラグ
    processFlag.value = 2;
    //編集ページ表示 OFF
    editPage.value = false;
    //確認ページ表示 ON
    confirmPage.value = true;
  };

  return {
    errdialog,
    errMessage,
    editPage,
    confirmPage,
    processFlag,
    confirmDeleteDialog,
    addressDialog,
    areaDialog,
    overlay,
    displayListSettingDialog,
    displayListSearchDialog,
    onClickListSearch,
    openListPage,
    openConfirmDeletePage,
  };
};
